import React from 'react';
import { MenuHeaderLogo, useMenuHeader } from '@templates/Menu/MenuHeader/common';
import { OrderingUnavailableHeaderDetails } from './OrderingUnavailableHeaderDetails.ui';
import { CustomerOrLogin } from '@olo-web/components/molecules/CustomerOrLogin';
import { Flex, Skeleton, Text, Box } from '@chakra-ui/react';
import { WideScreenContainer } from '@olo-web/components/atoms/WideScreenContainer';
import { useMerchantDisplayName, useMerchantImages } from '@domain/merchants/hooks';

export const OrderingUnavailableHeaderDesktop = () => {
  const { merchant, group, bg } = useMenuHeader();
  const { logoUrl } = useMerchantImages();
  const merchantName = useMerchantDisplayName();
  const isLoading = !merchant || !group;

  return (
    <>
      <Box w="100%" bg="white">
        <WideScreenContainer data-testid="header-section">
          <Flex pt={8} pb={4} px={10}>
            {isLoading && (
              <Skeleton
                variant="rect"
                h="100%"
                w={{ md: '240px', lg: '320px' }}
                mr={8}
                borderRadius={4}
              />
            )}
            {!isLoading && !!logoUrl && (
              <Flex
                justify="center"
                align="center"
                flexDir="column"
                h="160px"
                w={{ md: '242px', lg: '320px' }}
                mr={8}
                borderRadius={4}
                pos="relative"
                {...bg}
              >
                <MenuHeaderLogo src={logoUrl} />
              </Flex>
            )}
            <Flex flexDir="column" flex={1}>
              <Flex justify="space-between" align="flex-start" w="100%" zIndex="2">
                {isLoading ? (
                  <Skeleton w="500px" h="40px" />
                ) : (
                  <Text as="h1" textStyle="h1" flex={1} data-testid="location-name" noOfLines={2}>
                    {merchantName}
                  </Text>
                )}
                <CustomerOrLogin />
              </Flex>
              <OrderingUnavailableHeaderDetails />
            </Flex>
          </Flex>
        </WideScreenContainer>
      </Box>
    </>
  );
};
